module.exports = __webpack_public_path__ + "img/normal-you3.72b6e259.png";